/*global jQuery, matrixData */
/**
 * {{name}}
 * Global JS
 *
 * version: {{version}}
 * file:    {{file}}
 * author:  Squiz Australia
 * change log:
 *     {{date}} - First revision
 */

/*
 * Table of Contents
 *
 * - Global
 * - Modules
{{toc}}
 */
'use strict';
/*
--------------------
Global
--------------------
*/
//  Declare JS Enabled.
// $('body').removeClass('no-js').addClass('js-enabled');
//only apply plugin to homepage
if($("body").hasClass("s-home")){
  addToHomescreen({
    // debug: true,
    skipFirstVisit: false,
    maxDisplayCount: 0,
    displayPace: 0
    // lifespan: 1000
  });
}

// Global Variables
const $window = $(window),
  $document = $(document),
  $body = $('body'),
  liveSite = window.location.host.indexOf(':3000') == -1,
  mqLarge = 960;

$.Sq = $.Sq || {};

$( init );
function init() {
  $.Sq.DetectUserAgent.init();
  $.Sq.Menu.init();
  $.Sq.ServiceWorker.init();
  if($("body").hasClass("s-home")){
      $.Sq.HomeHeroFix.init();
  }
}

$.Sq.HomeHeroFix = ( function(module) {
  module.fixHeroPosition = function () {
    var headerH = document.querySelectorAll('.s-home .p-header')[0].offsetHeight;
  	var hwrapperH = document.querySelectorAll('.s-home .p-header__wrapper')[0].offsetHeight;
  	var heroH = document.querySelectorAll('.p-hero__wrapper')[0].offsetHeight;

    var heroTop = (headerH + hwrapperH - heroH) * 2 / 5;

    if(headerH > heroH) {
  		document.querySelectorAll('.p-hero__wrapper')[0].style.top = heroTop + 'px';
  	} else {
      document.querySelectorAll('.s-home .p-header')[0].style.height = hwrapperH + heroH + 'px';
  		document.querySelectorAll('.p-hero__wrapper')[0].style.top = hwrapperH + 20 + 'px';
  	}
  };

  module.addListener = function () {
    window.addEventListener("resize", module.fixHeroPosition);
  };

  module.init = function() {
    module.fixHeroPosition();
    module.addListener();
  };

  return module;
})( $.Sq.HomeHeroFix || {} );

$.Sq.ServiceWorker = (function( module ) {
  module.initServiceWorker = function(){
    console.log('SERVICE WORKERS AVAILABLE!');
    navigator.serviceWorker.register(matrixData.urlServiceWorker).then(function(registration) {
      // Registration was successful
      console.log('ServiceWorker registration successful with scope: ', registration.scope);
    }).catch(function(err) {
      // registration failed :(
      console.log('ServiceWorker registration failed: ', err);
    });
  };

  module.init = function() {
    //if browser is able to use service workers
    if ('serviceWorker' in navigator) {
      //then register service worker!
      module.initServiceWorker();
    }
  };

  return module;
})( $.Sq.ServiceWorker || {} );

$.Sq.DetectUserAgent = (function( module ) {
  module.detectUA = function() {
    window.addEventListener('load', function() {
      if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
        document.querySelector('html').classList.add('is-IE');
      }
    });
  };

  module.init = function() {
    module.detectUA();
  };

  return module;
})( $.Sq.DetectUserAgent || {} );

$.Sq.Menu = (function( module ) {
  function handleMenuIndicator(overlayClass, show) {
    const $pageWrapper = $('.o-page-wrapper');

    if (show) {
      if ($pageWrapper.hasClass(overlayClass)) {
        $pageWrapper.removeClass(overlayClass);
      }
      else {
        $pageWrapper.addClass(overlayClass);
      }
    }
    else {
      $pageWrapper.removeClass(overlayClass);
    }
  };

  function updateMenuAria($checkbox, show) {
    if (!$checkbox) {
      return;
    }

    let $menu = $checkbox.parent().find('.js-menu-wrapper');

    if (show) {
      $checkbox.attr('aria-expanded', 'true');
      $menu.attr('aria-hidden', 'false');
    }
    else {
      if ($checkbox.is(':checked')) {
        $checkbox.attr('aria-expanded', 'true');
        $menu.attr('aria-hidden', 'false');
      }
      else {
        $checkbox.attr('aria-expanded', 'false');
        $menu.attr('aria-hidden', 'true');
      }
    }
  };

  module.initMenuAria = function() {
    let $menuCheckbox = $('.js-menu-checkbox'),
      indicatorClass = 'is-nav-expanded';;

    $window.on('load resize', () => {
      $menuCheckbox.map((i) => {
        let $this = $($menuCheckbox[i]);

        if ($window.width() < mqLarge) {
          updateMenuAria($this);
        }
        else {
          $menuCheckbox.prop('checked', false);
          updateMenuAria($this, true);
          handleMenuIndicator(indicatorClass, false);
        }
      });
    })
  };

  module.toggleMenuPanel = function() {
    let $menuCheckbox = $('.js-menu-checkbox'),
      indicatorClass = 'is-nav-expanded';

    $menuCheckbox.on('change', (e) => {
      let $this = $(e.currentTarget);

      updateMenuAria($this);
      handleMenuIndicator(indicatorClass, true);
    });
  };

  module.closeMenu = function() {
    let $menuCheckbox = $('.js-menu-checkbox'),
      indicatorClass = 'is-nav-expanded';

    $document.on('click touchend', (e) => {
      if ($menuCheckbox.is(':checked') && $window.width() < mqLarge) {
        // click or touch outside the menu area
        if (!$(e.target).parents('.p-nav__wrapper').length) {
          $menuCheckbox.prop('checked', false);
          updateMenuAria($menuCheckbox);
          handleMenuIndicator(indicatorClass, true);
        }
      }
    });
  };

  module.init = function() {
    module.initMenuAria();
    module.toggleMenuPanel();
    module.closeMenu();
  };

  return module;
})( $.Sq.Menu || {} );
